// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"538ae7bc","372":"538ae7bc"}[chunkId] + ".chunk.css";
};